<template>
  <v-dialog
    v-model="eventDutiesDialog"
    transition="dialog-bottom-transition"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    max-width="60%"
    scrollable
  >
    <v-card>
      <v-toolbar
        dark
        flat
        color="secondary"
        scrollable
      >
        <v-btn
          icon
          dark
          @click.native="eventDutiesDialog = false"
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>בעלי תפקידים</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          dark
          flat
          large
          @click.native="createDuty"
        >
          הוספה
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-progress-linear
          v-if="fetching"
          height="2"
          indeterminate
        />
        <v-data-table
          v-else
          :headers="headers"
          :items="duties"
          hide-actions
          must-sort
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td>{{ props.item.startDate ? format(props.item.startDate, 'DD/MM/YYYY HH:mm') : null }}</td>
            <td>{{ props.item.endDate ? format(props.item.endDate, 'DD/MM/YYYY HH:mm') : null }}</td>
            <td>{{ $store.state.entities.users[props.item.user] ? $store.state.entities.users[props.item.user].name : 'משתמש לא מזוהה' }}</td>
            <td>{{ $store.state.entities.roles[props.item.role] ? $store.state.entities.roles[props.item.role].title : 'תפקיד לא מזוהה' }}</td>
            <td>
              <v-btn
                small
                icon
                flat
                class="mt-2 ml-0 mr-0"
                :loading="editing[props.item._id]"
                @click="editDuty(props.item, false)"
              >
                <v-icon small>
                  edit
                </v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn
                small
                icon
                flat
                class="mt-2 ml-0 mr-0"
                :loading="removing[props.item._id]"
                @click="removeDuty(props.item._id)"
              >
                <v-icon small>
                  delete
                </v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { format } from "date-fns";
import { getApi } from "@/api";
import generateId from "@/idGenerator";

export default {
  data() {
    return {
      editing: {},
      removing: {},
      fetching: true,
      headers: [
        { text: "זמן התחלה", value: "startDate", align: "right" },
        { text: "זמן סיום", value: "endDate", align: "right" },
        {
          text: "שם",
          value: "user",
          align: "right"
        },
        { text: "תפקיד", value: "role", align: "right" },
        { text: "עריכה", value: "edit", sortable: false, align: "right" },
        { text: "מחיקה", value: "delete", sortable: false, align: "right" }
      ]
    };
  },

  computed: {
    eventDutiesDialog: {
      get() {
        return this.$store.getters["events/eventDutiesDialog"];
      },
      set(isActive) {
        this.$store.commit("events/TOGGLE_EVENT_DUTIES_DIALOG", isActive);
      }
    },
    eventId() {
      return this.$route.params.id;
    },
    duties() {
      return Object.values(this.$store.state.entities.duties).filter(item => {
        return (item.event._id ? item.event._id: item.event ) === this.eventId;
      });
    },
    // items() {
    //   return this.duties.map(item => {
    //     return {
    //       user: item.user.name,
    //       role: item.role.title,
    //       startDate: item.startDate,
    //       endDate: item.endDate
    //     }
    //   });
    // },
    entityEditDialog: {
      get() {
        return this.$store.state.entityEditDialog;
      },
      set(payload) {
        this.$store.commit("TOGGLE_ENTITY_EDIT_DIALOG", payload);
      }
    }
  },

  methods: {
    format,
    createDuty() {
      let newEntity = {
        _id: generateId(),
        event: this.eventId
      };
      this.editDuty(newEntity, true);
    },
    editDuty(entity, isNew) {
      this.$store.commit("ADD_EDITABLE_ENTITY", {
        entity,
        schema: "dutySchema"
      });
      this.$store.commit("SET_ENTITY_EDIT_DATA", {
        id: entity._id,
        resource: this.$store.state.resources.duty,
        isNew
      });
      this.entityEditDialog = true;
    },
    removeDuty(id) {
      this.$confirm("האם למחוק?").then(res => {
        if (!res) {
          return;
        }

        this.removing[id] = true;
        this.$store
          .dispatch("CLEAR_CACHE")
          .then(() => {
            // return this.$store.dispatch("partners/REMOVE_PARTNER", eventId);
            return this.$store.dispatch("REMOVE_ENTITY", {
              url: this.$store.state.resources.duty.endpoint,
              entityType: this.$store.state.resources.duty.entityType,
              id
            });
          })
          .then(() => {
            this.$store.dispatch("SHOW_SNACKBAR", {
              text: "התפקיד נמחק",
              color: "success"
            });
          })
          .catch(err => {
            this.$store.dispatch("SHOW_SNACKBAR", {
              text: err.response ? err.response.data.message : err.message,
              color: "error"
            });
          })
          .finally(() => {
            this.removing[id] = false;
          });
      });
    },
    fetch() {
      console.log('fetch');
      this.fetching = true;
      this.$store
        .dispatch("API_GET", {
          url: "/duties",
          entityType: "duties",
          schema: "dutyListSchema",
          params: {
            q: JSON.stringify({ event: this.eventId }),
            limit: 0
          }
        })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.fetching = false;
        });
    }
  },

  beforeMount() {},

  mounted() {
  },

  watch: {
    eventDutiesDialog: {
      handler: function(val) {
        if (!val) {
          // this.reset();
        } else {
          this.fetch();
        }
      },
      immediate: true
    },
    // Refetch when event IDs to show change
    '$store.getters["events/eventIdsToShow"]': {
      handler() {
        // Update eventId to the current event
        this.eventId = this.$route.params.id;
        if (this.eventDutiesDialog) {
          this.fetch();
        }
      },
      deep: true
    },
    // Watch for route changes to refetch data when switching events
    '$route.params.id': {
      handler(newEventId) {
        if (newEventId && newEventId !== this.eventId) {
          this.eventId = newEventId;
          if (this.eventDutiesDialog) {
            this.fetch();
          }
        }
      },
      immediate: true
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/events/EventDutiesDialog.vue